var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bumpyChart',{attrs:{"width":600,"height":350,"cfgs":_vm.configs,"bgcolor":_vm.transparent,"line-color":'#000',"xtags":_vm.xtags,"datas":_vm.datas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }